import {Component, computed, inject, input} from '@angular/core';
import {ContentfulService} from '../../../core/services/contentful.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
    selector: 'wci-logo-cloud',
    imports: [],
    templateUrl: './logo-cloud.component.html',
    styles: ``,
})
export class LogoCloudComponent {
    service = inject(ContentfulService);
    items = toSignal(this.service.getCustomerLogos());


    limit = input<number>();
    highlightedOnly = input<boolean>();

    limitedItems = computed(() => {
        let items = this.items() || [];

        if (this.highlightedOnly()) {
            items = items.filter((e) => !!e.fields.highlighted);
        }

        return items.slice(0, this.limit());
    });
}
